import React, { use, useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import Navbar from "../navbar/navbar";
import Datatable from "../../datatable/Datatable";
import AlertConfirmation from "../../common/AlertConfirmation.component";
import { createJaThaPra, getJaThaPraMasterList } from "../../services/admin.service";
import { useNavigate } from "react-router-dom";

const JaThaPraMasterListComponent = () => {

    const [jaThaPraList, setJaThaPraList] = useState([]);
    const loginId = Number(localStorage.getItem('loginId'));
    const navigate = useNavigate();

    useEffect(() => {
        fetchJaThaPraList();
    }, []);

    const fetchJaThaPraList = async () => {
        try {
            const response = await getJaThaPraMasterList();
            if (response) {
                setJaThaPraList(response);
            } else {
                setJaThaPraList([]);
                Swal.fire("Error", "Failed to fetch Ja Tha Pra list", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while fetching Ja Tha Pra list", "error");
            console.error(error);
        }
    };

    const validationSchema = Yup.object({
        newRate: Yup.number()
            .required("New rate is required")
            .positive("Rate must be positive")
            .typeError("Rate must be a number"),
    });

    const initialValues = {
        newRate: "",
    };

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const payload = {
                janaTheerthaPrasada: "Additional Ja Tha Pra",
                rate: values.newRate,
                isValid: 1,
                isActive: 1,
                createdBy: loginId,
                createdDate: new Date().toISOString(),
            };
            const confirm = await AlertConfirmation({ title: "Are you sure to update!", message: '' });
            if (!confirm) return;
            const result = await createJaThaPra(payload);
            if (result) {
                Swal.fire({
                    icon: "success",
                    title: "New Ja Tha Pra Rate Updated",
                    text: `New Ja Tha Pra Rate: ${values.newRate}`,
                });
                fetchJaThaPraList();
            } else {
                Swal.fire("Error", "Failed to update rate", "error");
            }
            resetForm();
        } catch (error) {
            Swal.fire("Error", "Failed to update rate", "error");
        }
    };

    const handleBack = () => {
        navigate("/dashboard");
    };


    return (
        <div className="card">
            <Navbar />
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h3 className="admin-custom-heading">Manage JaThaPra</h3>
                    </div>
                </div>
            </div>
            <div className="container mb-4">
                <div className="card shadow-lg p-4">
                    <div className="card-header text-center bg-primary text-white fw-bold fs-5">
                        Ja Tha Pra Rate Update
                    </div>
                    <div className="card-body">
                        <div className="mb-3">
                            {jaThaPraList.length > 0 && (
                                <>
                                    <label className="form-label fw-semibold">Current Ja Tha Pra Rate</label>
                                    <div className="form-control-plaintext fs-4 text-success">
                                        ₹{jaThaPraList[0]?.rate}
                                    </div>
                                </>
                            )}
                        </div>

                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {() => (
                                <Form>
                                    <div className="mb-3">
                                        <label htmlFor="newRate" className="form-label fw-semibold">
                                            New Ja Tha Pra Rate
                                        </label>
                                        <Field
                                            type="number"
                                            name="newRate"
                                            className="form-control"
                                            placeholder="Enter new rate"
                                        />
                                        <ErrorMessage
                                            name="newRate"
                                            component="div"
                                            className="text-danger mt-1"
                                        />
                                    </div>
                                    <div className="text-center mt-4">
                                        <button type="submit" className="submit me-2">{jaThaPraList.length > 0 ? "Update" : "Submit"}</button>
                                        <button type="button" className="back" onClick={handleBack}>Cancel</button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default JaThaPraMasterListComponent;